import { getFilenameParts } from '.';

/**
 * Given a filename and a new base name, rename the file. Useful when you don't know the extension
 * of the file you are renaming.
 *
 * If the filename argument does not include an extension, the baseName is returned without an
 * extension.
 *
 * Example:
 * renameFile('foo.mp3', 'user-audio-file') => 'user-audio-file.mp3'
 *
 * @param filename string the full filename including the extension
 * @param newBaseName string the desired new base name
 */
export const renameFile = (filename: string, newBaseName: string): string => {
    const { extension } = getFilenameParts(filename);

    if (extension === null) {
        return newBaseName;
    }

    return `${newBaseName}.${extension}`;
};
